import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { sliderApi } from "../api/sliderApi";

export default function SliderEdit() {
  const { id } = useParams();
  const nav = useNavigate();

  const [titleAz, setTitleAz] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [titleRu, setTitleRu] = useState("");

  const [descAz, setDescAz] = useState("");
  const [descEn, setDescEn] = useState("");
  const [descRu, setDescRu] = useState("");

  const [imageFile, setImageFile] = useState(null);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await sliderApi.getById(id);
        const d = res.data || {};

        setTitleAz(d.titleAz ?? "");
        setTitleEn(d.titleEn ?? "");
        setTitleRu(d.titleRu ?? "");

        setDescAz(d.descAz ?? "");
        setDescEn(d.descEn ?? "");
        setDescRu(d.descRu ?? "");
      } catch (e) {
        alert(e?.response?.data || e.message || "Not found");
        nav("/sliders");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await sliderApi.update(id, {
        titleAz, titleEn, titleRu,
        descAz, descEn, descRu,
        imageFile
      });
      nav("/sliders");
    } catch (err) {
      alert(err?.response?.data || err.message || "Update failed");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="card"><div className="cardBody">Yüklənir...</div></div>;
  }

  return (
    <div>
      <h1 className="pageTitle">Edit Slider #{id}</h1>

      <div className="grid2">
        <div className="card">
          <div className="cardHead">
            <div className="cardTitle">Current Image</div>
            <span className="badge badgeOk">Preview</span>
          </div>
          <div className="cardBody">
            <img
              alt="current"
              src={sliderApi.getImageUrl(id) + `?t=${Date.now()}`}
              style={{
                width: "100%",
                maxWidth: 520,
                height: 240,
                objectFit: "cover",
                borderRadius: 14,
                border: "1px solid rgba(255,255,255,.12)"
              }}
            />
          </div>
        </div>

        <div className="card">
          <div className="cardHead">
            <div className="cardTitle">Update Form</div>
            <span className="badge">PUT</span>
          </div>
          <div className="cardBody">
            <form className="form" onSubmit={submit}>
              <div>
                <span className="label">Title (AZ)</span>
                <input className="input" value={titleAz} onChange={(e) => setTitleAz(e.target.value)} />
              </div>

              <div>
                <span className="label">Title (EN)</span>
                <input className="input" value={titleEn} onChange={(e) => setTitleEn(e.target.value)} />
              </div>

              <div>
                <span className="label">Title (RU)</span>
                <input className="input" value={titleRu} onChange={(e) => setTitleRu(e.target.value)} />
              </div>

              <div>
                <span className="label">Desc (AZ)</span>
                <textarea className="textarea" rows={4} value={descAz} onChange={(e) => setDescAz(e.target.value)} />
              </div>

              <div>
                <span className="label">Desc (EN)</span>
                <textarea className="textarea" rows={4} value={descEn} onChange={(e) => setDescEn(e.target.value)} />
              </div>

              <div>
                <span className="label">Desc (RU)</span>
                <textarea className="textarea" rows={4} value={descRu} onChange={(e) => setDescRu(e.target.value)} />
              </div>

              <div>
                <span className="label">New Image (optional)</span>
                <input type="file" accept="image/*" onChange={(e) => setImageFile(e.target.files?.[0] || null)} />
              </div>

              <div className="btnRow">
                <button className="btn btnPrimary" disabled={saving}>
                  {saving ? "Saving..." : "Save"}
                </button>
                <button type="button" className="btn" onClick={() => nav("/sliders")}>
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
